export default __webpack_public_path__ + "static/media/fintech-2-dk.946287a3.svg";